import { call, put } from "redux-saga/effects";
import Swal from "sweetalert2";
import { API_BASE_URL, getRequest, postRequest, putRequest, deleteRequest } from "../../../api";

import {
    FETCH_MODULES_CLE_REQUEST,
    fetchModulesCleSuccess,
    fetchModulesCleFail,
    createModuleCleSuccess,
    createModuleCleFail,
    updateModuleCleSuccess,
    updateModuleCleFail,
    deleteModuleCleSuccess,
    deleteModuleCleFail,
    setModulesCleLoading,
} from "../actions/modulesCleActions";

const getUid = () => sessionStorage.getItem("uid");
const getToken = () => sessionStorage.getItem("token");

export function* fetchModulesCleSaga() {
    const url = `${API_BASE_URL}/api/modules-cle`;
    yield put(setModulesCleLoading(true));
    try {
        const resp = yield call(getRequest, { url, uid: getUid(), token: getToken() });
        yield put(fetchModulesCleSuccess(resp.data));
    } catch (e) {
        yield put(fetchModulesCleFail(e.response?.data?.message || e.message));
    } finally {
        yield put(setModulesCleLoading(false));
    }
}

export function* createModuleCleSaga(action) {
    const url = `${API_BASE_URL}/api/modules-cle`;
    yield put(setModulesCleLoading(true));
    try {
        const resp = yield call(postRequest, { url, data: action.payload, uid: getUid(), token: getToken() });
        yield put(createModuleCleSuccess(resp.data));
        yield call([Swal, Swal.fire], { icon: "success", text: "Module ajouté", timer: 1400, showConfirmButton: false });
        yield put({ type: FETCH_MODULES_CLE_REQUEST });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur ajout module";
        yield put(createModuleCleFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setModulesCleLoading(false));
    }
}

export function* updateModuleCleSaga(action) {
    const { id, payload } = action.payload;
    const url = `${API_BASE_URL}/api/modules-cle/${id}`;
    yield put(setModulesCleLoading(true));
    try {
        const resp = yield call(putRequest, { url, data: payload, uid: getUid(), token: getToken() });
        yield put(updateModuleCleSuccess(resp.data));
        yield call([Swal, Swal.fire], { icon: "success", text: "Module modifié", timer: 1400, showConfirmButton: false });
        yield put({ type: FETCH_MODULES_CLE_REQUEST });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur modification module";
        yield put(updateModuleCleFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setModulesCleLoading(false));
    }
}

export function* deleteModuleCleSaga(action) {
    const { id } = action.payload;
    const url = `${API_BASE_URL}/api/modules-cle/${id}`;
    yield put(setModulesCleLoading(true));
    try {
        yield call(deleteRequest, { url, uid: getUid(), token: getToken() });
        yield put(deleteModuleCleSuccess(id));
        yield call([Swal, Swal.fire], { icon: "success", text: "Module supprimé", timer: 1400, showConfirmButton: false });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur suppression module";
        yield put(deleteModuleCleFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", text: msg, timer: 2200, showConfirmButton: false });
    } finally {
        yield put(setModulesCleLoading(false));
    }
}
